import cn from "classnames";
import Image from "next/image";
import {useGameContext} from "@/context/GameContext";
const Torch = ({parentStyle, className, ...props}) => {

	const {isMobile} = useGameContext()

	return (
		<div className={cn(className)} {...props}>
			{isMobile ? <Image src={'/images/Game/Torch/torch_mobile.png'}
			                  alt={"Torch"}
			                  className={cn(parentStyle.torch__gif, 'torch')}
			                  id={'torch'}
			                  width={20}
			                  height={60}
	                          unoptimized={true}
			/> : <Image src={'/images/Game/Torch/torch.gif'}
			       alt={"Torch"}
			       className={cn(parentStyle.torch__gif, 'torch')}
			       id={'torch'}
			       width={20}
			       height={60}
			/>}
		</div>
	)

}
export default Torch